export const initLayoutConfig = {
    demo: "demo1",
    self: {
        layout: "fluid",
        // A arte é a mesma nas quatro variantes de skin: o logo é escuro e a moldura do painel é
        // clara em todos os estados, então não existe versão clara para inverter. Os caminhos vêm
        // codificados porque o nome do arquivo tem espaço.
        logo: {
            dark: "/images/PRL%20LOGO%20BGW.png",
            light: "/images/PRL%20LOGO%20BGW.png",
            brand: "/images/PRL%20LOGO%20BGW.png",
            green: "/images/PRL%20LOGO%20BGW.png",
        },
    },
    loader: {
        enabled: true,
        type: "spinner-logo",
        logo: "/images/PRL%20ICONE%20BGW.png",
        message: "Aguarde...",
    },
    colors: {
        state: {
            brand: "#354764",
            dark: "#1f2328",
            light: "#ffffff",
            primary: "#354764",
            accent: "#793354",
            success: "#1a7f37",
            info: "#0969da",
            warning: "#9a6700",
            danger: "#cf222e",
        },
        base: {
            label: ["#6e7781", "#6e7781", "#59636e", "#1f2328"],
            shape: ["#f6f8fa", "#f0f2f5", "#b8c0ca", "#59636e"],
        },
    },
    toolbar: {
        display: true,
    },
    header: {
        self: {
            width: "fluid",
            skin: "light",
            fixed: {
                desktop: true,
                mobile: true,
            },
        },
        menu: {
            self: {
                display: true,
                layout: "default",
                "root-arrow": true,
                "icon-style": "duotone",
            },
            desktop: {
                arrow: true,
                toggle: "click",
                submenu: {
                    skin: "light",
                    arrow: true,
                },
            },
            mobile: {
                submenu: {
                    skin: "dark",
                    accordion: true,
                },
            },
        },
    },
    subheader: {
        display: true,
        displayDesc: false,
        displayDaterangepicker: true,
        layout: "subheader-v1",
        fixed: false,
        width: "fluid",
        clear: false,
        style: "solid",
    },
    content: {
        width: "fluid",
    },
    brand: {
        self: {
            skin: "light",
        },
    },
    aside: {
        self: {
            skin: "light",
            display: true,
            fixed: true,
            minimize: {
                toggle: true,
                default: false,
            },
        },
        footer: {
            self: {
                display: true,
            },
        },
        menu: {
            dropdown: "false",
            scroll: false,
            "icon-style": "duotone",
            submenu: {
                accordion: true,
                dropdown: {
                    arrow: true,
                    "hover-timeout": 100,
                },
            },
        },
    },
    footer: {
        self: {
            width: "fluid",
            fixed: false,
        },
    },
};

const LayoutConfig = JSON.parse(JSON.stringify(initLayoutConfig)); // deep object copy
export default LayoutConfig;
